import { css } from '@emotion/core'
import normalizeCss from './normalize.css'

const normalize = css`
  ${normalizeCss}
`

export default normalize
